import { render, staticRenderFns } from "./UpsertResourceWrapper.vue?vue&type=template&id=845077cc&lang=pug&"
import script from "./UpsertResourceWrapper.vue?vue&type=script&lang=js&"
export * from "./UpsertResourceWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports